export const MESSAGE_COMMON_ERROR = '문제가 발생했습니다. 다시 시도해 주세요.';
export const MESSAGE_EDIT_SUCCESS = '변경 사항을 저장했습니다.';
export const MESSAGE_CREATE_SUCCESS = '새로운 논의가 추가되었습니다.';
export const MESSAGE_COPY_SUCCESS = '클립보드에 복사되었습니다.';



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/shared/message.ts